module.exports = __webpack_public_path__ + "images/lpage-cards-2.png";